import { render, staticRenderFns } from "./DatasetEditModal.vue?vue&type=template&id=6e46c2fd&"
import script from "./DatasetEditModal.vue?vue&type=script&lang=js&"
export * from "./DatasetEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DatasetEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports